import { useMsal } from "@azure/msal-react";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserMaintanenceData } from "../Redux/UserMaintanence";
import "./ShowAccessOnToolTip.css";

export default function ShowAccessOnToolTip() {
 const [userAccessRole, setUserAccessRole] = useState([]);

 let loggedInEnterpriseId = "";

 const userData = useSelector((state) => state.userRoles.UserMaintanenceData);
 const dispatch = useDispatch();
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 if (activeAccount) {
  loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
 }

 useEffect(() => {
  dispatch(getUserMaintanenceData());
 }, []);

 useEffect(() => {
  setUserAccessRole(userData);
 }, [userData]);

 let filteredUserAccesRole =
  userAccessRole.length !== 0
   ? userAccessRole.filter((user) => {
      return user.Enterprise_ID === loggedInEnterpriseId;
     })
   : [];

 let typeOfUser =
  filteredUserAccesRole.length === 0
   ? "request_access"
   : filteredUserAccesRole[0].Admin === "yes"
   ? "Admin"
   : filteredUserAccesRole[0].Approver === "yes"
   ? "Approver"
   : filteredUserAccesRole[0].Requestor === "yes"
   ? "Requestor"
   : "inactive";

 return (
  <>
   <Tooltip
    title={typeOfUser === "inactive" || typeOfUser === "request_access" ? "" : typeOfUser}
   >
    {typeOfUser === "Admin" ? (
     <img
      src={process.env.PUBLIC_URL + "/Images/UserAccess/admin.png"}
      className="user_access_img"
     />
    ) : typeOfUser === "Approver" ? (
     <img
      src={process.env.PUBLIC_URL + "/Images/UserAccess/approver.png"}
      className="user_access_img"
     />
    ) : typeOfUser === "Requestor" ? (
     <img
      src={process.env.PUBLIC_URL + "/Images/UserAccess/requestor.png"}
      className="user_access_img"
     />
    ) : typeOfUser === "inactive" ? (
     "Inactive"
    ) : (
     <a href="mailto:ATCI.L-TT.CommsBuilder.Support@accenture.com">Request Access</a>
    )}
   </Tooltip>
  </>
 );
}
